import { useWatch } from '@graphcommerce/ecommerce-ui'
import { Money } from '@graphcommerce/magento-store'
import { useFormAddProductsToCart } from '@graphcommerce/magento-product/components/AddProductsToCart'
import { ProductPagePriceFragment } from '@graphcommerce/magento-product/components/ProductPagePrice/ProductPagePrice.gql'
// import { getProductTierPrice } from '@graphcommerce/magento-product/components/ProductPagePrice/getProductTierPrice'
import { Box } from "@mui/material";
import { useCustomerPrices } from '../../hooks/useCustomerPrices'

type ProductPagePriceProps = {
  product: ProductPagePriceFragment,
  index?: number,
  url_key?: string |null
}

export function ProductPagePrice(props: ProductPagePriceProps) {
  const { product, index = 0, url_key } = props

  // const { control } = useFormAddProductsToCart()
  // const quantity = useWatch({ control, name: `cartItems.${index}.quantity` })
  const { regular_price } = product.price_range.minimum_price
  // const { price_tiers } = product
  // const final_price = getProductTierPrice(product, quantity) ?? product.price_range.minimum_price.final_price
  // const price = getProductTierPrice(product, quantity) ?? product.price_range.minimum_price.final_price

  const customerPrices = useCustomerPrices({url_key})

  if (!customerPrices) return null

  const { final_price, special_price } = customerPrices
  const { value: customerFinalPriceValue } = final_price
  const customerFinalPriceExclTax = {...final_price}
  customerFinalPriceExclTax.value = Number(customerFinalPriceValue) / 1.21

  return (
    <Box component='div'
         sx={{
           display: 'flex',
           flexDirection: 'column',
           alignItems: 'flex-end',
           gap: '.5rem'
         }}
    >
      <Money {...customerFinalPriceExclTax} />
      <Box
        component='span'
        sx={{
          display: 'inline-block',
          textDecoration: special_price ? 'line-through' : 'none',
          color: 'text.disabled',
          fontSize: '1rem',
        }}
      >
        PVR: <Money {...regular_price} />
      </Box>
      {(special_price) && (
        <Box
          component='span'
          sx={{
            display: 'inline-block',
            color: 'text.disabled',
            fontSize: '1rem',
          }}
        >
          PVR: <Money {...special_price} />
        </Box>
      )}
    </Box>
  )

  // return <Money {...price} />
}
